:host {
  display: table;
  width: 100%;
  height: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  table-layout: fixed;
  font-family: var(--sc-font-sans);
  // border: 0 1px 1px 1px solid var(--sc-color-gray-200);
  // overflow:hidden;
  border-radius: var(--border-radius, var(--sc-border-radius-small));
  // box-shadow: var(--shadow, var(--sc-shadow-medium));
}

:host([shadowed]) {
  box-shadow: var(--sc-shadow-medium);
}

::slotted([slot='head']) {
  border-bottom: 1px solid var(--sc-table-border-bottom-color, var(--sc-color-gray-200));
}
